import { ConcreteEncodable } from "./ConcreteEncodable";

import { TrailingStopDetailsImplEncoder } from "../../encoder/TrailingStopDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { TrailingStopDetails } from "../TrailingStopDetails";

export class TrailingStopDetailsImpl extends ConcreteEncodable implements TrailingStopDetails {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.TrailingStopDetailsImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=951*/
  public initialTrailingRt: CubiqTS.BigNumber | null = null;
  /*FID=952*/
  public trailingDistancePts: CubiqTS.BigNumber | null = null;
  /*FID=953*/
  public invertTrailingDistancePts: CubiqTS.BigNumber | null = null;
  /*FID=954*/
  public initialTrackingRt: CubiqTS.BigNumber | null = null;
  /*FID=955*/
  public isInitialTrailingRateProvidedFg: boolean;
  /*FID=956*/
  public isTrackingActive: boolean;
  /*FID=957*/
  public origTrackingRt: CubiqTS.BigNumber | null = null;
  /*FID=958*/
  public trailingRt: CubiqTS.BigNumber | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TrailingStopDetailsImplEncoder.Instance;
    this.setEncodableType(TrailingStopDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TrailingStopDetailsImpl[" +
      "messageId=" +
      this.messageId +
      "initialTrailingRt=" +
      this.initialTrailingRt +
      "trailingDistancePts=" +
      this.trailingDistancePts +
      "invertTrailingDistancePts=" +
      this.invertTrailingDistancePts +
      "initialTrackingRt=" +
      this.initialTrackingRt +
      "isInitialTrailingRateProvidedFg=" +
      this.isInitialTrailingRateProvidedFg +
      "isTrackingActive=" +
      this.isTrackingActive +
      "origTrackingRt=" +
      this.origTrackingRt +
      "trailingRt=" +
      this.trailingRt +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
